import * as React from 'react';
import { Box, Container, CssBaseline, Paper, Typography } from '@mui/material';
import 'react-phone-number-input/style.css'
import { Outlet, useLocation } from 'react-router-dom';
import { SourceProvider } from '../hooks/useSource';
import PHIAlert from '../components/PHIAlert';


const LoginPage = (): JSX.Element => {
    const location = useLocation();
    return <React.Fragment>
    <SourceProvider source={location?.state?.from?.pathname + location?.state?.from?.search}>
        <CssBaseline />
        <Container
            sx={{
                maxWidth: '10000px !important',
                height: '100vh',
                background: '#eee',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: 2,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexGrow: 0.8,
                }}
            >
                <Paper sx={{ width: '500px', height: '335px', padding: 4, marginBottom: 2 }}>
                    <Outlet />
                </Paper>
            </Box>

            <PHIAlert />

            <Box sx={{ paddingBottom: 1 }}>
                <Typography align="center">
                    {`${process.env.REACT_APP_GIT_REVISION} | ${process.env.REACT_APP_BUILD_TIME}`}
                </Typography>
            </Box>
        </Container>
    </SourceProvider>
</React.Fragment>
};

export default LoginPage;